import { Helmet } from "react-helmet-async";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import Gallery from "@/components/Gallery";
import TrustedPartners from "@/components/TrustedPartners";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyPhone from "@/components/StickyPhone";
import { useGalleryImages } from "@/hooks/useGalleryImages";
import { Loader2 } from "lucide-react";

const CommercialGallery = () => {
  const { images, loading } = useGalleryImages("commercial");

  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Commercial Gallery | Hill Brothers</title>
        <meta name="description" content="Browse our commercial painting projects across New Hampshire. Offices, retail spaces, warehouses, and more. Call 603 424 4608." />
        <meta property="og:title" content="Commercial Gallery | Hill Brothers" />
        <meta property="og:description" content="See our commercial painting work across New Hampshire. Offices, retail spaces, warehouses, and multi-unit properties." />
        <meta property="og:url" content="https://hillbrothersnh.com/commercial" />
        <meta property="og:type" content="website" />
        <meta name="twitter:title" content="Commercial Gallery | Hill Brothers" />
        <meta name="twitter:description" content="See our commercial painting work across New Hampshire." />
        <link rel="canonical" href="https://hillbrothersnh.com/commercial" />
        <script type="application/ld+json">{JSON.stringify({
          "@context":"https://schema.org","@type":"BreadcrumbList",
          itemListElement:[
            {"@type":"ListItem",position:1,name:"Home",item:"https://hillbrothersnh.com/"},
            {"@type":"ListItem",position:2,name:"Commercial Gallery",item:"https://hillbrothersnh.com/commercial"}
          ]
        })}</script>
      </Helmet>

      <Header />
      
      <main className="pt-20">
        {/* Hero Banner */}
        <section className="bg-primary py-16">
          <div className="section-container">
            <Link 
              to="/" 
              className="inline-flex items-center gap-2 text-primary-foreground/80 hover:text-primary-foreground mb-4 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Home
            </Link>
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-primary-foreground mb-4">
              Commercial Projects
            </h1>
            <p className="text-xl text-primary-foreground/80 max-w-2xl">
              From office buildings to retail spaces, see our commercial painting and contracting work across New Hampshire.
            </p>
          </div>
        </section>

        {loading ? (
          <div className="flex justify-center py-20">
            <Loader2 className="w-8 h-8 animate-spin text-primary" />
          </div>
        ) : (
          <Gallery
            id="commercial-gallery"
            title="Our Commercial Work"
            subtitle="Professional painting solutions for businesses of all sizes."
            images={images}
          />
        )}

        <TrustedPartners />
      </main>
      
      <Footer />
      <StickyPhone />
    </div>
  );
};

export default CommercialGallery;
